import request from '@/utils/request'

export function login(account, sms_code) {
  return request({
    url: '/api/login',
    method: 'post',
    data: {
      account,
      sms_code
    }
  })
}

export function getInfo(role_id) {
  return request({
    url: '/api/login/userAuth',
    method: 'post',
    data: {
      role_id: role_id
    }
  })
}

export function logout(token) {
  return request({
    url: '/api/login/logout',
    method: 'post',
    data: {
      token: token
    }
  })
}

export function logsms(account) {
  return request({
    url: '/api/login/logsms',
    method: 'post',
    data: {
      account: account
    }
  })
}

export function fetchList(params) {
  return request({
    url: '/api/sys/user/info/paginate',
    method: 'post',
    data: {
      keyword: params.keyword,
      page_num: params.page_num,
      page_size: params.page_size
    }
  })
}

export function createAdmin(params) {
  return request({
    url: '/api/sys/user/info/save',
    method: 'post',
    data: {
      user_name: params.user_name,
      user_phone: params.user_phone,
      email: params.email,
      remark: params.remark,
      status_flag: params.status_flag,
    }
  })
}

export function updateAdmin(params) {
  return request({
    url: '/api/sys/user/info/update',
    method: 'post',
    data: {
      user_id: params.user_id,
      user_name: params.user_name,
      user_phone: params.user_phone,
      email: params.email,
      remark: params.remark,
      status_flag: params.status_flag,
    }
  })
}

export function enableStatus(user_id) {
  return request({
    url: '/api/sys/user/info/enable',
    method: 'post',
    data: {
      user_id: user_id
    }
  })
}

export function disableStatus(user_id) {
  return request({
    url: '/api/sys/user/info/disable',
    method: 'post',
    data: {
      user_id: user_id
    }
  })
}

export function deleteAdmin(user_id) {
  return request({
    url: '/api/sys/user/info/delete',
    method: 'post',
    data: {
      user_id: user_id
    }
  })
}

export function getRoleByAdmin(user_id) {
  return request({
    url: '/api/sys/user/info/rolelist',
    method: 'post',
    data: {
      user_id: user_id,
    }
  })
}

export function allocRole(user_id, role_id) {
  return request({
    url: '/api/sys/user/info/assignrole',
    method: 'post',
    data: {
      user_id: user_id,
      role_id: role_id
    }
  })
}

export function noSecret(data) {
  return request({
    url: '/api/login/auth/open',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js